define('views/blocks/checkout/CagnotteCheckoutDialogView',['views/blocks/checkout/CheckoutDialogView','app','template!blocks/checkout/dialog-cagnotte'],
    function (CheckoutDialogView,app,dialogCagnotteTemplate) {

    var localDecimalMark = (1.1).toLocaleString().substring(1, 2);

        return CheckoutDialogView.extend({
            events:{
                'keydown .input':'onKey',
                'keyup .input':'onKeyUp',
                'change .input': 'onChange',
                'click .btn-remove--input':'onClickClear',
            },
            initialize:function(options){
                CheckoutDialogView.prototype.initialize.apply(this, arguments);
            },
            getInner:function(){
                var value = app.getCart().getCagnotte();
                if(!(value>0)) value = '';
                value = value.toString().replace(/[,\.]/,localDecimalMark);
                return dialogCagnotteTemplate({customer:app.getCustomer(),value:value});
            },
            getSubmitText:function(){
                return app.getCustomer().getCagnotteAmount() ?  app.t('Valider','UI') : app.t('OK','UI');
            },
            afterIntro:function(){
                var input = this.$('.input'),
                el = input.get(0);
                if(!el) return;
                // autofocus
                // if(!Modernizr.touchevents){
                //     new Cleave(el,{
                //         numeral: true,
                //         numeralDecimalMark: localDecimalMark,
                //         delimiter: '',
                //         numeralPositiveOnly: true,
                //     });
                // }
                input.focus();
            },
            getInputVal:function(){
                var input = this.$('input'),
                    inputVal = input.val(),
                    floatVal = parseFloat((inputVal||'0').replace(/[\-a-z€£]/gi,'').replace(',','.'))
                return floatVal;
            },
            setInputVal:function(num){
                var view = this,
                    input = view.$('.input'),
                    replacement;
                if(_.isUndefined(num)){num = view.getInputVal()}
                replacement = num.toString().replace(/[\-a-z€£]/gi,'').replace(/[\.,]+/g,'.');
                input.val(replacement);
                return parseFloat(replacement);
            },
            onClickClear:function(){
                this.$('.input').val('');
                this.onChange();
            },
            onChange:function(){
                this.$('.btn-remove--input').attr('data-value',this.$('.input').val());
                this.setInputVal();
            },
            onKeyUp:function(e){
                this.onKey(e);
            },
            onKey:function(e){
                switch(e.key){
                    case '.':
                    case ',':
                        if(!/\.|,/.test(e.currentTarget.value) && !app.isMobile()){
                            e.currentTarget.value += localDecimalMark;
                        }
                        break;
                }
            },
            submit:function(){
                var view = this,
                    inputVal = view.setInputVal(),
                    cagnotte = Math.min(app.getCart().getPriceTTC(),inputVal),
                    cagnotteAmount = parseFloat(app.getCustomer().getCagnotteAmount()) || 0;
                // TODO
                if(cagnotteAmount<cagnotte){
                    app.alert({
                        title:app.t('Attention','UI'),
                        subtitle:app.t('Vous dépassez la limite de crédit dans votre cagnotte.','Checkout'),
                    },function(){
                        view.setInputVal(cagnotteAmount.toFixed(2));
                    });
                    return false;
                }
                app.getCart().setCagnotte(cagnotte);
                view.close();
                return false;
            }
        });
    });
